import { InputFilterTrigger } from '@src/shared/features/views/components/static-filter-inputs';

import { leadCalendlyTypeFilterConfig } from '../../../configs/lead-calendly-type-filter-config';
import { LeadCalendlyTypeFilterSelectedValues } from '../../../configs/lead-calendly-type-filter-config/filter-selected-values';

export const LeadCalendlyTypeFilter = () => {
  return (
    <InputFilterTrigger
      filterLabel='Source'
      config={leadCalendlyTypeFilterConfig}
      renderValues={({ filter }) => (
        <LeadCalendlyTypeFilterSelectedValues filter={filter} />
      )}
    />
  );
};
